export const FlexContainer = ({ fill, direction, gap, children, style, justify, wrap, ...props }) => {
    return(
        <div {...props} style={{ ...style, width: fill ? '100%' : 'auto', display: 'flex', flexDirection: direction, gap: gap, justifyContent: justify, flexWrap: wrap && 'wrap'}}>
            {children}
        </div>
    )
}